import PropTypes from 'prop-types';
import { Box } from '@chakra-ui/react';

export default function RichTextSizeIndicator({ size, maxSize = 5 }) {
  return (
    <Box
      position="absolute"
      bottom="2"
      right="2"
      bg="gray.100"
      px="2"
      py="1"
      borderRadius="md"
      fontSize="sm"
      color={size > maxSize ? 'red.500' : 'gray.600'}
    >
      {size.toFixed(2)} MB / {maxSize} MB
    </Box>
  );
}

RichTextSizeIndicator.propTypes = {
  size: PropTypes.number.isRequired,
  maxSize: PropTypes.number,
};

RichTextSizeIndicator.defaultProps = {
  maxSize: 5,
};
